module.exports = __webpack_public_path__ + "img/EEDC.b86fcd52.svg";